import React from "react"

import Table from "./Table"
import Button from "@material-ui/core/Button"
import SaveIcon from "@material-ui/icons/Save"
import styled from "@emotion/styled"
import SearchIndicator from "@nvdb-rapport/shared/src/components/SearchIndicator"
import Alert from "@material-ui/lab/Alert"
import AlertTitle from "@material-ui/lab/AlertTitle"

import { AppState, UIModel } from "../../store/ui"

interface SearchResultProps {
  uiState: UIModel
}

export function SearchResult({ uiState }: SearchResultProps) {
  const searchResult = uiState.searchResult
  const appState = uiState.appState
  const tableheaderRef = React.useRef<HTMLHeadingElement | null>(null)

  React.useEffect(() => {
    if (appState === AppState.DATA_READY) {
      setTimeout(() => {
        window.scrollTo({
          behavior: "smooth",
          top: tableheaderRef.current ? tableheaderRef.current.offsetTop : 1000,
        })
      }, 500)
    }
  }, [appState])
  if (appState === AppState.DATA_PENDING) {
    return (
      <div
        style={{
          maxWidth: "600px",
          width: "100%",
          margin: "1rem",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
        >
          <div style={{ fontWeight: "bold" }}>
            {appState === AppState.DATA_PENDING
              ? "Genererer vegliste"
              : "Henter"}
          </div>
          <div style={{ textAlign: "right" }}>
            <div>{searchResult.durationMsString.substring(0, 8)}</div>
          </div>
        </div>
        <SearchIndicator />
      </div>
    )
  }

  if (
    searchResult &&
    appState === AppState.DATA_READY &&
    searchResult.tableData === null
  ) {
    return (
      <p>
        {searchResult.durationMsString.substring(0, 8)} Ingen vegliste funnet
        for disse parameterene.
      </p>
    )
  } else if (
    searchResult &&
    appState === AppState.DATA_READY &&
    searchResult.tableData !== null
  ) {
    return (
      <div style={{ width: "100%" }}>
        <div
          style={{
            margin: "1rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Alert
            style={{
              margin: "1rem 0",
              maxWidth: "600px",
              width: "100%",
              justifyContent: "center",
            }}
            severity="success"
          >
            <AlertTitle ref={tableheaderRef} style={{ fontWeight: "bold" }}>
              Ferdig ({searchResult.durationMsString.substring(0, 8)})
            </AlertTitle>
          </Alert>

          <DownloadButtonsContainer>
            <Button
              href={searchResult.downloadLinkXLSX}
              variant="contained"
              color="secondary"
              // className={classes.button}
              startIcon={<SaveIcon />}
              disabled={searchResult.downloadLinkXLSX.includes("/undefined?")}
            >
              Lagre veglister som .XLSX
            </Button>
            <Button
              href={searchResult.downloadLinkDOCX}
              variant="contained"
              color="secondary"
              // className={classes.button}
              startIcon={<SaveIcon />}
              disabled={searchResult.downloadLinkDOCX.includes("/undefined?")}
            >
              Lagre veglister som .DOCX
            </Button>
            <Button
              href={searchResult.downloadLinkCSV}
              variant="contained"
              color="secondary"
              // className={classes.button}
              startIcon={<SaveIcon />}
              disabled={searchResult.downloadLinkCSV.includes("/undefined?")}
            >
              Lagre veglister som .CSV
            </Button>
          </DownloadButtonsContainer>
          {searchResult !== undefined && searchResult.tableData !== null && (
            <Table data={searchResult.tableData} />
          )}
        </div>
      </div>
    )
  } else {
    return <div></div>
  }
}

const DownloadButtonsContainer = styled.div`
  display: flex;
  width: 60%;
  margin: 0 auto;
  justify-content: space-evenly;
  margin-bottom: 4.8rem;
`
